import { AppRelease } from '../models'
import {lastReleaseDateKey} from '../types/app_release'
import moment from 'moment'

export async function fetchReleases(releaseDate: moment.Moment) {
  const releasesRef = AppRelease.listenToReleases(releaseDate)
  const querySnapshot = await releasesRef.get()
  const releases: AppRelease[] = []

  querySnapshot.forEach(doc => {
    releases.push(new AppRelease(doc))
  })

  return releases
}

export function getStoredReleaseDate() {
  const date = localStorage.getItem(lastReleaseDateKey)
  return date ? (moment(date).isValid() ? moment(date) : moment().subtract(1, 'days')) : moment().subtract(1, 'days')
}

export function storeReleaseDate(date: moment.Moment) {
  localStorage.setItem(lastReleaseDateKey, date.toISOString())
}

export async function checkForNewReleases() {
  const lastReleaseDate = getStoredReleaseDate()
  const newReleases = await fetchReleases(lastReleaseDate)

  if (newReleases.length > 0) {
    const latestReleaseDate = moment(newReleases[0].releaseDate)
    storeReleaseDate(latestReleaseDate)
    return newReleases
  }
}
